<template>
  <section v-bind="$attrs" class="esg-happiness">
    <navigation-sub
      :list="[
        {
          title: $t('commitment.name'),
          anchor: $t('commitment.title')
        },
        {
          title: $t('report.title'),
          anchor: $t('report.title'),
        }
      ]"
    />

    <div class="esg-title-wrap">
      <h4 class="esg-title">{{ $t('menuSustainability.happiness') }}</h4>
    </div>

    <!-- 지속가능을 위한 배민다운 약속 -->
    <article
      :id="hashTitle($t('commitment.title'))"
      class="article-anchor esg-box happiness-commitment"
    >
      <div class="esg-box-image">
        <p>
          <img src="../../../static/image/sustainability/img-happiness-1.png" :alt="$t('happiness.name')">
        </p>
      </div>
      <html-view :value="$t('commitment.title')" class="esg-box-title" />
      <div class="esg-box-content">
        <p>{{ $t('commitment.paragraph') }}</p>
        <small>{{ $t('commitment.subParagraph') }}</small>
        <div class="goal-2030">
          <h6>{{ $t('commitment.goals') }}</h6>
          <ul class="card-list">
            <li class="card-item">
              <icon-goal-1 />
              <div class="card-item-content">
                <strong>{{ $t('commitment.list.item1.title') }}</strong>
                <html-view :value="$t('commitment.list.item1.content')" tag="p" />
              </div>
            </li>
            <li class="card-item">
              <icon-goal-2 />
              <div class="card-item-content">
                <strong>{{ $t('commitment.list.item2.title') }}</strong>
                <html-view :value="$t('commitment.list.item2.content')" tag="p" />
              </div>
            </li>
            <li class="card-item">
              <icon-goal-3 />
              <div class="card-item-content">
                <strong>{{ $t('commitment.list.item3.title') }}</strong>
                <html-view :value="$t('commitment.list.item3.content')" tag="p" />
                <small>{{ $t('commitment.list.item3.note') }}</small>
              </div>
            </li>
          </ul>
        </div>
        <ol class="list-number">
          <li class="list-number-item">
            <p class="list-number-heading">
              <i class="number" />
              <strong>{{ $t('commitment.growing.title') }}</strong>
            </p>
            <html-view :value="$t('commitment.growing.paragraph')" tag="p" class="paragraph" />
            <div class="btn-wrap">
              <router-link
                v-if="getCategory('Baemin Academy')"
                :to="{
                  name: 'sustainability-together',
                  params: {
                    category: getCategory('Baemin Academy').params.category,
                    locale: $route.params.locale
                  }
                }"
                class="btn-link"
                @click.native="onScrollToNavigation"
              >
                {{ $t('commitment.growing.link1') }}<icon-blank class="icon-blank" />
              </router-link>
              <router-link
                v-if="getCategory('Grow Together')"
                :to="{
                  name: 'sustainability-together',
                  params: {
                    category: getCategory('Grow Together').params.category,
                    locale: $route.params.locale
                  }
                }"
                class="btn-link"
                @click.native="onScrollToNavigation"
              >
                {{ $t('commitment.growing.link2') }}<icon-blank class="icon-blank" />
              </router-link>
            </div>
            <ul class="card-list">
              <li class="card-item column">
                <icon-ceo-1 />
                <div class="card-item-content">
                  <strong>{{ $t('commitment.growing.card.item1.title') }}</strong>
                  <html-view :value="$t('commitment.growing.card.item1.content')" tag="p" />
                </div>
              </li>
              <li class="card-item column">
                <icon-ceo-2 />
                <div class="card-item-content">
                  <strong>{{ $t('commitment.growing.card.item2.title') }}</strong>
                  <html-view :value="$t('commitment.growing.card.item2.content')" tag="p" />
                </div>
              </li>
              <li class="card-item column">
                <icon-ceo-3 />
                <div class="card-item-content">
                  <strong>{{ $t('commitment.growing.card.item3.title') }}</strong>
                  <html-view :value="$t('commitment.growing.card.item3.content')" tag="p" />
                </div>
              </li>
              <li class="card-item column">
                <icon-ceo-4 />
                <div class="card-item-content">
                  <strong>{{ $t('commitment.growing.card.item4.title') }}</strong>
                  <html-view :value="$t('commitment.growing.card.item4.content')" tag="p" />
                </div>
              </li>
              <li class="card-item column">
                <icon-ceo-5 />
                <div class="card-item-content">
                  <strong>{{ $t('commitment.growing.card.item5.title') }}</strong>
                  <html-view :value="$t('commitment.growing.card.item5.content')" tag="p" />
                </div>
              </li>
            </ul>
          </li>
          <li class="list-number-item">
            <p class="list-number-heading"><i class="number" /><strong>{{ $t('commitment.safety.title') }}</strong></p>
            <html-view :value="$t('commitment.safety.paragraph')" tag="p" class="paragraph" />
            <div class="btn-wrap">
              <a href="https://www.woowayouths.com/social/safety" class="btn-link" target="_blank">{{ $t('commitment.safety.link1') }}<icon-blank class="icon-blank" /></a>
            </div>
            <ul class="card-list">
              <li class="card-item column">
                <icon-riders-1 />
                <div class="card-item-content">
                  <strong>{{ $t('commitment.safety.card.item1.title') }}</strong>
                  <html-view :value="$t('commitment.safety.card.item1.content')" tag="p" />
                </div>
              </li>
              <li class="card-item column">
                <icon-riders-2 />
                <div class="card-item-content">
                  <strong>{{ $t('commitment.safety.card.item2.title') }}</strong>
                  <html-view :value="$t('commitment.safety.card.item2.content')" tag="p" />
                </div>
              </li>
              <li class="card-item column">
                <icon-riders-3 />
                <div class="card-item-content">
                  <strong>{{ $t('commitment.safety.card.item3.title') }}</strong>
                  <html-view :value="$t('commitment.safety.card.item3.content')" tag="p" />
                </div>
              </li>
              <li class="card-item column">
                <icon-riders-4 />
                <div class="card-item-content">
                  <strong>{{ $t('commitment.safety.card.item4.title') }}</strong>
                  <html-view :value="$t('commitment.safety.card.item4.content')" tag="p" />
                </div>
              </li>
              <li class="card-item column">
                <icon-riders-5 />
                <div class="card-item-content">
                  <strong>{{ $t('commitment.safety.card.item5.title') }}</strong>
                  <html-view :value="$t('commitment.safety.card.item5.content')" tag="p" />
                </div>
              </li>
            </ul>
          </li>
          <li class="list-number-item">
            <p class="list-number-heading"><i class="number" /><strong>{{ $t('commitment.green.title') }}</strong></p>
            <html-view :value="$t('commitment.green.paragraph')" tag="p" class="paragraph" />
            <div class="btn-wrap">
              <router-link
                v-if="getCategory('Baemin Green')"
                :to="{
                  name: 'sustainability-together',
                  params: {
                    category: getCategory('Baemin Green').params.category,
                    locale: $route.params.locale
                  }
                }"
                class="btn-link"
                @click.native="onScrollToNavigation"
              >
                {{ $t('commitment.green.link1') }}<icon-blank class="icon-blank" />
              </router-link>
            </div>
            <ul class="card-list">
              <li class="card-item column">
                <icon-green-1 />
                <div class="card-item-content">
                  <strong>{{ $t('commitment.green.card.item1.title') }}</strong>
                  <html-view :value="$t('commitment.green.card.item1.content')" tag="p" />
                </div>
              </li>
              <li class="card-item column">
                <icon-green-2 />
                <div class="card-item-content">
                  <strong>{{ $t('commitment.green.card.item2.title') }}</strong>
                  <html-view :value="$t('commitment.green.card.item2.content')" tag="p" />
                </div>
              </li>
              <li class="card-item column">
                <icon-green-3 />
                <div class="card-item-content">
                  <strong>{{ $t('commitment.green.card.item3.title') }}</strong>
                  <html-view :value="$t('commitment.green.card.item3.content')" tag="p" />
                </div>
              </li>
              <li class="card-item column">
                <icon-green-4 />
                <div class="card-item-content">
                  <strong>{{ $t('commitment.green.card.item4.title') }}</strong>
                  <html-view :value="$t('commitment.green.card.item4.content')" tag="p" />
                </div>
              </li>
              <li class="card-item column">
                <icon-green-5 />
                <div class="card-item-content">
                  <strong>{{ $t('commitment.green.card.item5.title') }}</strong>
                  <html-view :value="$t('commitment.green.card.item5.content')" tag="p" />
                </div>
              </li>
            </ul>
            <html-view :value="$t('commitment.green.card.note')" tag="small" />
          </li>
        </ol>
      </div>
    </article>

    <!-- 가치경영보고서 -->
    <article
      :id="hashTitle($t('report.title'))"
      class="article-anchor esg-box happiness-report"
    >
      <html-view :value="$t('report.title')" class="esg-box-title" />
      <div class="esg-box-content">
        <div class="paragraph">{{ $t('report.paragraph') }}</div>
        <div class="btn-wrap">
          <a
            target="_blank"
            :href="download['2025'].ko"
            class="btn-download"
            download
          >{{ $t('report.link1') }}<icon-download class="icon icon-download" /></a>
          <a
            target="_blank"
            class="btn-download"
            :href="download['2025'].en"
            download
          >{{ $t('report.link2') }}<icon-download class="icon icon-download" /></a>
        </div>
        <p class="esg-box-image">
          <!--          <picture>-->
          <!--            <source media="(min-width: 750px)" srcset="../../../static/image/sustainability/img-happiness-2025@2x.jpg 3x">-->
          <!--            <source media="(max-width: 750px)" srcset="../../../static/image/sustainability/img-happiness-2025.jpg">-->
          <!--            <img src="../../../static/image/sustainability/img-happiness-2025.jpg" :alt="$t('report.name')">-->
          <!--          </picture>-->

          <img :src="require(`../../../static/image/sustainability/img-happiness-2025${locale === 'en' ? '-en' : ''}.jpg`)" :alt="$t('report.name')">
        </p>
        <div class="link-select">
          <button
            class="link-select-button"
            type="button"
            :class="{
              'link-select-active': isReportShow
            }"
            @click="onSelectToggle"
          >
            <span>
              {{ $t('report.download.default') }}
            </span>
            <span class="down"><icon-chevron-down /></span>
          </button>
          <transition name="link-select">
            <ul v-if="isReportShow" class="link-select-list">
              <li>
                <a target="_blank" download :href="download['2024'].ko">{{ $t('report.download.item7') }}<icon-download-light class="icon icon-download" /></a>
              </li>
              <li>
                <a target="_blank" download :href="download['2024'].en">{{ $t('report.download.item6') }}<icon-download-light class="icon icon-download" /></a>
              </li>
              <li>
                <a target="_blank" download :href="download['2023'].ko">{{ $t('report.download.item5') }}<icon-download-light class="icon icon-download" /></a>
              </li>
              <li>
                <a target="_blank" download :href="download['2023'].en">{{ $t('report.download.item4') }}<icon-download-light class="icon icon-download" /></a>
              </li>
              <li>
                <a target="_blank" download :href="download['2022'].ko">{{ $t('report.download.item3') }}<icon-download-light class="icon icon-download" /></a>
              </li>
              <li>
                <a target="_blank" download :href="download['2022'].en">{{ $t('report.download.item2') }}<icon-download-light class="icon icon-download" /></a>
              </li>
              <li>
                <a target="_blank" download :href="download['2021'].ko">{{ $t('report.download.item1') }}<icon-download-light class="icon icon-download" /></a>
              </li>
            </ul>
          </transition>
        </div>
      </div>
    </article>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { hashTitle } from '@/util'
const tempPdf = require('@/static/download/우아한형제들 가치경영보고서 배민스토리2025.pdf')

export default {
  components: {
    iconCeo1: () => import('@/static/image/sustainability/icon-ceo-1.svg'),
    iconCeo2: () => import('@/static/image/sustainability/icon-ceo-2.svg'),
    iconCeo3: () => import('@/static/image/sustainability/icon-ceo-3.svg'),
    iconCeo4: () => import('@/static/image/sustainability/icon-ceo-4.svg'),
    iconCeo5: () => import('@/static/image/sustainability/icon-ceo-5.svg'),
    iconGoal1: () => import('@/static/image/sustainability/icon-goal-1.svg'),
    iconGoal2: () => import('@/static/image/sustainability/icon-goal-2.svg'),
    iconGoal3: () => import('@/static/image/sustainability/icon-goal-3.svg'),
    iconGreen1: () => import('@/static/image/sustainability/icon-green-1.svg'),
    iconGreen2: () => import('@/static/image/sustainability/icon-green-2.svg'),
    iconGreen3: () => import('@/static/image/sustainability/icon-green-3.svg'),
    iconGreen4: () => import('@/static/image/sustainability/icon-green-4.svg'),
    iconGreen5: () => import('@/static/image/sustainability/icon-green-5.svg'),
    iconRiders1: () => import('@/static/image/sustainability/icon-riders-1.svg'),
    iconRiders2: () => import('@/static/image/sustainability/icon-riders-2.svg'),
    iconRiders3: () => import('@/static/image/sustainability/icon-riders-3.svg'),
    iconRiders4: () => import('@/static/image/sustainability/icon-riders-4.svg'),
    iconRiders5: () => import('@/static/image/sustainability/icon-riders-5.svg'),
    iconBlank: () => import('@/static/svg/blank.svg'),
    iconDownload: () => import('@/static/svg/download.svg'),
    iconDownloadLight: () => import('@/static/svg/download-light.svg'),
    iconChevronDown: () => import('@/static/svg/chevron-down.svg'),
    navigationSub: () => import('@/components/base/NavigationSub'),
  },
  data () {
    return {
      isReportShow: false,
      download: {
        2025: {
          ko: require('@/static/download/우아한형제들_가치경영보고서_배민스토리2025.pdf'),
          en: require('@/static/download/Baemin_Story_2025.pdf')
        },
        2024: {
          ko: require('@/static/download/배민스토리2024.pdf'),
          en: require('@/static/download/BaeminStory2024.pdf')
        },
        2023: {
          ko: require('@/static/download/배민스토리2023.pdf'),
          en: require('@/static/download/BaeminStory2023.pdf')
        },
        2022: {
          ko: require('@/static/download/배민스토리2022.pdf'),
          en: require('@/static/download/BaeminStory2022.pdf')
        },
        2021: {
          ko: require('@/static/download/배민스토리2021.pdf')
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      locale: 'locale/GET_LOCALE',
      writingCategories: 'categories/get_writing_categories',
    }),
  },
  methods: {
    hashTitle,
    getCategory (name) {
      return this.writingCategories.map(v => {
        const newCategory = { ...v }
        newCategory.path = 'sustainability-together'
        newCategory.name = this.isKorean ? newCategory.categoryKoreaName : newCategory.categoryEnglishName
        newCategory.params = { category: newCategory.categorySeq }
        // newCategory.query = { page: 1 }

        return newCategory
      }).find(v => v.name === name)
    },
    onSelectToggle () {
      this.isReportShow = !this.isReportShow

      const docEvents = (e) => {
        if (!e.target.closest('.link-select')) {
          this.isReportShow = false
          document.documentElement.removeEventListener('click', docEvents)
        }
      }

      document.documentElement.addEventListener('click', docEvents)
    },
    onScrollToNavigation () {
      setTimeout(() => {
        const navigationTab = document.querySelector('.navigation-tab')

        document.documentElement.scrollTo({
          top: navigationTab.offsetTop
        })
      }, 10)
    }
  }
}
</script>
